(function () {
    'use strict';
    app.controller('userAccountController', ['$scope', '$location', '$cookies', '$rootScope', '$timeout', 'userAccountService', '$route', 'CommonService', 'progressBarService','LoginService', function ($scope, $location, $cookies, $rootScope, $timeout, userAccountService, $route, commonService, progressBarService, loginService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem("appInfo") == undefined) {
            $location.path('/login');
            return;
        }

        $scope.getAccountData = function () {
            progressBarService.showProgressBar();
            var subscriptionType, emailId;
            emailId = getLocalValue('emailId');

            userAccountService.getAccountData(emailId).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                } else {
                    $scope.accountData = response.data;
                }
            });
            progressBarService.hideProgressBar();
        }
        $scope.getAccountData();

        $scope.Alertdelete = function () {
            $scope.alerts = {
                alerHeaderMessage: '',
                alertBodyMessage: ''
            }
            $scope.alerts.alerHeaderMessage = GetMessage.recordsDeleteHeader;
            $scope.alerts.alertBodyMessage = GetMessage.recordsDeleteBody;

            $('#confirmDelete').modal({ backdrop: 'static', keyboard: false });
        }

        $scope.delete = function () {
            $('#confirmDelete').modal('hide');
            progressBarService.showProgressBar();
            //var eSpectraLastUpdateUserID = $cookies.get('UserId');
            var eSpectraEmail = getLocalValue('emailId');
            var userInfo = {}

            userAccountService.deleteRecords(userInfo).then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    progressBarService.hideProgressBar();
                } else {
                    $scope.message = "Account Deleted Successfully.";
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    sendConfirmationToUserDelete(eSpectraEmail);
                    $timeout(function () {
                        progressBarService.hideProgressBar();
                        loginService.logOut();
                        $location.path('/home');
                    },1000);
                }
            });
        }

        var sendConfirmationToUserDelete = function (userId) {
            loginService.sendConfirmationToUserDelete(userId);
        };

        $scope.alertCancel = function () {
            $scope.alerts = {
                alerHeaderMessage: '',
                alertBodyMessage: ''
            }
            $scope.alerts.alerHeaderMessage = GetMessage.cancelSubscriptionHeader;
            $scope.alerts.alertBodyMessage = GetMessage.cancelSubscriptionBody;

            $('#confirmCancel').modal({ backdrop: 'static', keyboard: false });
        }

        $scope.cancelSubscription = function () {
            $('#confirmCancel').modal('hide');
            //var eSpectraUserId = $cookies.get('UserId');
            userAccountService.cancelSubscription().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                } else {
                    $scope.message = "Subscription Cancelled Successfully.";
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    $scope.accountData.userSubscriptionType = '';

                }
                progressBarService.hideProgressBar();
            });
        }
    }]);

})();